export const enumGuessType = {"CLOSE": "close", "WRONG":"wrong","CORRECT":"correct"};
